import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { GroupFilterModel } from '../../shared/pipes/FilterByNameAndGroup.pipe';
import { BaseDialog } from "../BaseDialog";
import { IManagableObject } from "../IManagableObject";
import { ObjectGroupViewModel } from '../ObjectGroupViewModel';
import { CompaniesService, CompanyModel } from '../../../services/companies.service';
import { matchesSearchRule } from '../../shared/pipes/filterByProperty';

declare const $;



@Component({
  selector: 'app-objects-management-dialog',
  templateUrl: './objects-management-dialog.component.html',
  styleUrls: ['./objects-management-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ObjectsManagementDialogComponent extends BaseDialog implements OnInit {
  public readonly pageSizeOptions: number[] = [20, 50, 100];
  public filter: GroupFilterModel = new GroupFilterModel();
  public companies: CompanyModel[] = [];
  public companyNameById: { [key: number]: string } = {};
  public filteredObjects: IManagableObject[] = [];

  @Input() public isSingleItem: boolean = false;
  @Input() public groups: ObjectGroupViewModel[] = [];
  @Input() public title = "Objects list";
  @Input() public companyLookup: { [key: number]: string } | null = null;
  @Input() public showCompanyFilterAndColumn: boolean = false;
  private _isLoading: boolean = false;

  @Input()
  public get isLoading(): boolean {
    return this._isLoading;
  }

  public set isLoading(value: boolean) {
    this._isLoading = value;
    this.refreshView();
  }

  constructor(private companiesService: CompaniesService, private cdr: ChangeDetectorRef) {
    super();
  }

  public ngOnInit() {
    this.companiesService.getCompanies().subscribe(companies => {
      this.companies = companies ?? [];
      const lookup: { [key: number]: string } = {};
      (companies ?? []).forEach(company => {
        lookup[company.Id] = company.Name;
      });
      this.companyNameById = lookup;
      this.refreshView();
    });

    this.updateFilteredObjects();
  }

  public get resolvedCompanyLookup(): { [key: number]: string } {
    return this.companyLookup ?? this.companyNameById;
  }

  public selectGroup(group: ObjectGroupViewModel) {
    this.filter.group = group;
    setTimeout(function () { $(".dropclick").removeClass("opened"); }, 100);
    this.updateFilteredObjects();
  }

  public onTermChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.filter.term = input.value;
    this.updateFilteredObjects();
  }

  public onCompanyFilterChange(companyIds: number[] | null | undefined) {
    this.filter.companyIds = companyIds ?? [];
    this.updateFilteredObjects();
  }

  public onToggle(val: IManagableObject): void {
    if (this.isSingleItem) {
      const checked = val.IsChecked;
      this.objects.filter(o => o.Id != val.Id).forEach(value => value.IsChecked = false);
      this.selectObjectsCount = checked ? 1 : 0;
    }
    else
      super.onToggle(val);

    this.refreshView();
  }

  public trackByObjectId(index: number, object: IManagableObject): number {
    return object.Id;
  }

  public refreshView(): void {
    this.cdr.markForCheck();
  }

  protected onObjectsChanged(): void {
    this.updateFilteredObjects();
  }

  private updateFilteredObjects(): void {
    let filteredItems: IManagableObject[] = this.objects as IManagableObject[];

    if (this.filter.term && this.filter.term !== "") {
      filteredItems = filteredItems.filter(item => matchesSearchRule(item.Name, this.filter.term));
    }

    if (this.filter.group && this.filter.group.Id > 0) {
      const groupIds: Record<number, true> = {};
      for (let i = 0; i < this.filter.group.objects.length; i++) {
        groupIds[this.filter.group.objects[i]] = true;
      }
      filteredItems = filteredItems.filter(item => groupIds[item.Id]);
    }

    if (this.filter.companyIds?.length) {
      const selectedCompanyIds = new Set<number>(this.filter.companyIds);
      filteredItems = filteredItems.filter(item =>
        selectedCompanyIds.has(item.CompanyId ?? 0));
    }

    this.filteredObjects = filteredItems;
    this.refreshView();
  }
}
